const REJECT_REASON_MISMATCHING_TRANSLATION_SECTION_NAME = {
  key: 'menu_rejection_mismatching_translation_section_name',
  text: 'Mismatching translation - Section Name',
};

export const TALABAT_CATEGORY_REJECT_REASONS = [
  REJECT_REASON_MISMATCHING_TRANSLATION_SECTION_NAME,
];
